// Persist UTM params + landing page for the session, to attach on lead submit.
const KEY = "dic_utm_v1";
const UTM_FIELDS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const existing = getUtm();
    const next = { ...existing };
    let changed = false;
    UTM_FIELDS.forEach((f) => {
      const v = params.get(f);
      if (v) {
        next[f] = v;
        changed = true;
      }
    });
    if (!existing.landing_page) {
      next.landing_page = window.location.href;
      changed = true;
    }
    if (changed) sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    /* no-op */
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch (e) {
    return {};
  }
}
